import { IFormBuilderAssistant } from '../../../shared/components/form-builder/form-builder-assistant/iform-builder-assistant.interface';
import { FormTemplateDesign_FormBuilderAssistant } from '../design/form-builder-assistant';
import { FormField } from '../../../shared/models/form-builder/form-field.model';
import { FieldDefinitionService } from '../../../shared/services/field-definition.service';
import { RawHTMLFieldType } from '../../../shared/models/form-builder/form-field-types';

// Note:  the following class extends the existing form template 'assistant' while suppressing numerous functions.
export class FormTemplateHtmlFieldsDesign_FormBuilderAssistant extends FormTemplateDesign_FormBuilderAssistant implements IFormBuilderAssistant {
    public constructor() {
        super();
    }

    public canOnlyEditHtmlFields(): boolean {
        return true;
    }
    public canEditField(fieldDefinitionService: FieldDefinitionService, formField: FormField): boolean {
        return formField.fieldDefinitionClassName == RawHTMLFieldType;
    }
    public canEditTemplateProperties(): boolean {// Applies to site home pages as well, so where the term 'Template' is used in a general way.
        return false;
    }
}
